import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play_tv",
  "use": "play_tv-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"play_tv\"><path d=\"M11.84 9.173v13.76L22.827 16 11.84 9.173z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol